<div>
    <nz-date-picker
        [(ngModel)]="startTime"
        [nzAllowClear]="nzAllowClear"
        [nzDisabledDate]="disabledDate"
        nzPlaceHolder="Start Date"
        class="date-picker"
        (ngModelChange)="changeDate()"
    ></nz-date-picker>

    <nz-date-picker
        [(ngModel)]="endTime"
        [nzAllowClear]="nzAllowClear"
        [nzDisabledDate]="disabledDate"
        nzPlaceHolder="End Date"
        (ngModelChange)="changeDate()"
    ></nz-date-picker>
</div>
